module.exports = __webpack_public_path__ + "static/media/logo.a9677892.png";


//////////////////
// WEBPACK FOOTER
// ./src/Template/images/logo.png
// module id = 1202
// module chunks = 0